import { render, staticRenderFns } from "./EditCartSummary.vue?vue&type=template&id=51865aa5&scoped=true&"
import script from "./EditCartSummary.vue?vue&type=script&lang=js&"
export * from "./EditCartSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51865aa5",
  null
  
)

export default component.exports